import { defineComponent as _defineComponent } from 'vue'
import { ref, getCurrentInstance } from 'vue';
import axios from 'axios';
import { BookV1 } from '@ilteducation/content-registry-types';
import { Exercise, State, UnknownExercise } from '@ilteducation/exercise-service-types';
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import useMediaFormFeature from '@/comp/use-media-form-feature';
import EditContent from '@/components/exercise/EditContent.vue';
import upperFirst from 'lodash/upperFirst';
import { useRoute, useRouter } from 'vue-router/composables';

type Props = {
  id?: string;
  title: string;
  item: Exercise | UnknownExercise;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
    id: null,
    title: null,
    item: null
  },
  emits: ['removed'],
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  item: Exercise | UnknownExercise;
}




const route = useRoute();
const router = useRouter();
const returnTo = route.query.returnTo as string | undefined;

const { saveButtonAvailable } = useMediaFormFeature(props.item);

const handleSaved = () => {
  if (returnTo) {
    router.push(returnTo);
  }
};
const notEmptyRule = ref([(val: any) => (val || '').length > 0 || 'This field is required']);
const model = ref();
const getText = (val: BookV1) => `${val.title} - (${val.isbn}) - (${val.id})`;

const stateColor = ref(props.item?.state === 'new' ? 'red' : 'green');

const stateValue = ref(props.item?.state);

const expand = ref(true);

const updateState = async () => {
  const state: State = 'published';
  const url = `${process.env.VUE_APP_EXERCISES_API_URL}updateExerciseState`;
  await axios.request({
    url,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: {
      exerciseId: props.id,
      exerciseState: state,
    },
  });
  stateColor.value = 'green';
  stateValue.value = 'published';
};

return { __sfc: true,props, route, router, returnTo, saveButtonAvailable, handleSaved, notEmptyRule, model, getText, stateColor, stateValue, expand, updateState, DisableableButton, EditContent, upperFirst }
}

})